import React, { useMemo, useState } from 'react';

const OpenPlayImage = ({
  src,
  alt,
  width,
  height,
  className = '',
  fill = false,
  sizes,
  onClick,
  fallbackSrc = '/assets/images/no_image.png',
  ...props
}) => {
  const [imageSrc, setImageSrc] = useState(src);
  const [hasError, setHasError] = useState(false);

  const isExternal = useMemo(() => {
    const s = String(imageSrc || '');
    return s.startsWith('http://') || s.startsWith('https://');
  }, [imageSrc]);

  const imgStyle = useMemo(() => {
    const style = {};
    if (width != null) style.width = width;
    if (height != null) style.height = height;
    if (fill) {
      style.width = style.width || '100%';
      style.height = style.height || '100%';
    }
    return style;
  }, [fill, height, width]);

  const handleError = () => {
    if (!hasError && fallbackSrc && imageSrc !== fallbackSrc) {
      setHasError(true);
      setImageSrc(fallbackSrc);
      return;
    }
    setHasError(true);
  };

  if (fill) {
    return (
      <div className={`relative ${className}`} style={{ width: width || '100%', height: height || '100%' }}>
        <img
          src={imageSrc}
          alt={alt}
          className="absolute inset-0 w-full h-full object-cover"
          onError={handleError}
          onClick={onClick}
          style={imgStyle}
          sizes={sizes}
          {...props}
        />
      </div>
    );
  }

  return (
    <img
      src={imageSrc}
      alt={alt}
      className={className}
      onError={handleError}
      onClick={onClick}
      style={imgStyle}
      {...(isExternal ? {} : {})}
      {...props}
    />
  );
};

export default OpenPlayImage;
